module.exports = __webpack_public_path__ + "img/Bus.741c1f74.png";